import firedux from '../firedux'
import {getState, dispatch} from '../store'
import {fromJS} from 'immutable'

import {
  USERS_ENDPOINT
} from '../../config/constants'

import setUser from '../actions/set_user'

export default (uid) => {
  let user = getState().getIn(['users', uid])

  if (user) return Promise.resolve(user)

  const ENDPOINT = `${USERS_ENDPOINT}/${uid}`

  return firedux.ref.child(ENDPOINT).once('value')
    .then((snapshot) => {
      if (!snapshot.exists()) return null
      user = snapshot.val()
      dispatch(setUser(user))
      return fromJS(user)
    })
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/getters/user.js
 **/